import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Ativo', flex: 3 },
  { title: 'Valor bruto', flex: 1 },
  { title: 'Valor investido', flex: 1 },
  { title: 'Quantidade', flex: 1 },
  { title: 'Rentabilidade', flex: 1 },
];

export const portfolioAssetsListItemSeparatorHeight = 'stack.nano';
